export default __webpack_public_path__ + "static/media/image-cover.139a9910.png";